import { Action, createReducer, on } from '@ngrx/store';
import { userSessionsAdapter, UserSessionsState } from './sessions.state';
import { UserSessionActions } from './sessions.actions';

const initialState: UserSessionsState = userSessionsAdapter.getInitialState({
  currentSessionId: null,
});

const userSessionsReducer = createReducer(
  initialState,
  on(UserSessionActions.loadInitialSuccess, (state, { sessions }) => {
    return userSessionsAdapter.addMany(sessions, {
      ...state,
      currentSessionId: null,
    });
  }),
  on(UserSessionActions.addOne, (state, { session }) => {
    return userSessionsAdapter.addOne(session, state);
  }),
  on(UserSessionActions.upsertOne, (state, { session }) => {
    return userSessionsAdapter.upsertOne(session, state);
  }),
  on(UserSessionActions.upsertMany, (state, { sessions }) => {
    return userSessionsAdapter.upsertMany(sessions, state);
  }),
  on(UserSessionActions.removeOne, (state, { session }) => {
    return userSessionsAdapter.removeOne(session.userId, state);
  })
);

export function reducer(state: UserSessionsState | undefined, action: Action) {
  return userSessionsReducer(state, action);
}
